const EducationList = [
    {
        title: `Education`,
        items: [
            {
                college: `University of Central Florida`,
                degree: `Bachelor of Arts in Digital Media`,
                courses: `Relevant Coursework: Mobile Development, User-Centered Design,  Interactive Fundamentals`
            },
            {
                college: `Valencia College`,
                degree: `Associates of Arts`,
                courses: `Relevant Coursework: Fundamentals of Digital Media, Graphic Design Essentials`
            }
            
        ]
    },
];

export default EducationList